<template>
    <div v-if="booking">
        <div class="relative -mb-2 transition duration-500 loading-bar"></div>
        <div class="container container--sm-up">
            <AlertBubbles :alerts="alerts" />
            <div class="flex flex-wrap border rounded border-grey-150">
                <div
                    class="w-full px-6 py-10 border-b md:px-10 md:w-1/2 md:border-r md:border-b-0 border-grey-150"
                >
                    <div class="flex items-center mb-8">
                        <!-- prettier-ignore -->
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-label="">
                            <path d="M11.194 23.467C10.9622 23.4662 10.74 23.374 10.5757 23.2104L6.84818 19.477C6.76634 19.3962 6.70137 19.2999 6.65702 19.1938C6.61268 19.0876 6.58984 18.9737 6.58984 18.8587C6.58984 18.7437 6.61268 18.6298 6.65702 18.5236C6.70137 18.4175 6.76634 18.3212 6.84818 18.2404C7.01299 18.0779 7.2351 17.9869 7.46651 17.9869C7.69792 17.9869 7.92004 18.0779 8.08485 18.2404L11.194 21.3437L23.444 9.09371C23.6099 8.93915 23.8293 8.85501 24.056 8.85901C24.2826 8.86301 24.4989 8.95484 24.6592 9.11515C24.8196 9.27547 24.9114 9.49175 24.9154 9.71844C24.9194 9.94512 24.8352 10.1645 24.6807 10.3304L11.8473 23.1637C11.7665 23.258 11.6663 23.3339 11.5536 23.3862C11.4409 23.4386 11.3183 23.4661 11.194 23.467Z" fill="#FFC749"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.566406 1.23038C0.566406 0.747128 0.958157 0.355377 1.44141 0.355377H28.9806C29.4638 0.355377 29.8556 0.747128 29.8556 1.23038V28.7695C29.8556 29.2528 29.4638 29.6445 28.9806 29.6445H1.44141C0.958157 29.6445 0.566406 29.2528 0.566406 28.7695V1.23038ZM2.31641 2.10538V27.8945H28.1056V2.10538H2.31641Z" fill="#0A4976"/>
                            <path d="M10.9915 22.1195C10.8766 22.1198 10.7628 22.0972 10.6566 22.0531C10.5505 22.0091 10.4541 21.9444 10.3732 21.8629L6.63982 18.1295C6.55385 18.0494 6.4849 17.9528 6.43708 17.8455C6.38925 17.7382 6.36354 17.6223 6.36146 17.5048C6.35939 17.3873 6.381 17.2706 6.42501 17.1617C6.46902 17.0527 6.53452 16.9538 6.61761 16.8707C6.7007 16.7876 6.79967 16.7221 6.90862 16.6781C7.01758 16.6341 7.13428 16.6124 7.25176 16.6145C7.36925 16.6166 7.48512 16.6423 7.59245 16.6901C7.69978 16.738 7.79638 16.8069 7.87649 16.8929L10.9915 20.002L23.2415 7.75204C23.4055 7.58727 23.6282 7.4944 23.8607 7.49385C24.0931 7.49331 24.3163 7.58513 24.4811 7.74912C24.6458 7.91311 24.7387 8.13584 24.7393 8.36831C24.7398 8.60078 24.648 8.82394 24.484 8.98871L11.6507 21.822C11.5676 21.9149 11.4661 21.9893 11.3526 22.0406C11.239 22.0918 11.116 22.1187 10.9915 22.1195Z" fill="#0A4976"/>
                        </svg>
                        <p class="ml-4 text-lg font-medium text-blue-500">Appointment Details</p>
                    </div>

                    <ReviewSection
                        :fields="[
                            {
                                label: 'Appointment Type',
                                data: serviceType
                            },
                            {
                                label: 'Location',
                                data: booking.selectedAppointment.locationName
                            }
                        ]"
                    />

                    <ReviewSection
                        :fields="[
                            {
                                label: practitionerType,
                                data: booking.selectedAppointment.practitionerName
                            },
                            {
                                label: 'Appointment date & time',
                                data: displayDate
                            }
                        ]"
                    />

                    <a
                        :href="calendarLink"
                        target="_blank"
                        class="flex p-8 mt-8 rounded bg-grey-100"
                    >
                        <!-- prettier-ignore -->
                        <svg class="flex-shrink-0 mr-6" width="48" height="38" viewBox="0 0 48 38" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-label="Add to calendar">
                        <path d="M45.5941 15.4271C44.6787 12.3505 43.0345 9.50674 40.7838 7.10734C38.533 4.70794 35.7336 2.81463 32.5938 1.56821" stroke="#FFC749" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M23.4922 11.9916V20.565H32.3122" stroke="#FFC749" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4609 7.52353C14.0849 7.52353 7.29492 13.8824 7.29492 21.7265C7.29492 29.5707 14.0849 35.9296 22.4609 35.9296C30.8368 35.9296 37.6268 29.5707 37.6268 21.7265C37.6268 13.8824 30.8368 7.52353 22.4609 7.52353ZM5.32617 21.7265C5.32617 12.8642 12.9976 5.67978 22.4609 5.67978C31.9241 5.67978 39.5955 12.8642 39.5955 21.7265C39.5955 30.5889 31.9241 37.7733 22.4609 37.7733C12.9976 37.7733 5.32617 30.5889 5.32617 21.7265Z" fill="#0A4976"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M30.3752 1.82302C30.5874 1.35425 31.1651 1.13532 31.6657 1.33402C34.9418 2.63453 37.8627 4.60999 40.2111 7.1135C42.5595 9.61701 44.275 12.5841 45.2301 15.7942C45.376 16.2847 45.0697 16.793 44.546 16.9297C44.0223 17.0663 43.4795 16.7795 43.3336 16.2891C42.4579 13.346 40.8851 10.6256 38.732 8.33036C36.5789 6.03507 33.901 4.22391 30.8973 3.03157C30.3968 2.83287 30.163 2.29178 30.3752 1.82302Z" fill="#0A4976"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8821 1.40343C16.0627 1.88367 15.7933 2.41005 15.2805 2.57913C12.2048 3.59326 9.41266 5.24365 7.1118 7.40757C4.81095 9.5715 3.06053 12.1933 1.9907 15.0781C1.81234 15.559 1.25142 15.8135 0.737856 15.6465C0.224293 15.4794 -0.0474383 14.9541 0.130927 14.4732C1.29784 11.3266 3.20709 8.46691 5.71674 6.10662C8.22638 3.74632 11.2719 1.94617 14.6267 0.840015C15.1395 0.670935 15.7016 0.923183 15.8821 1.40343Z" fill="#0A4976"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4609 12.2313C23.0046 12.2313 23.4453 12.644 23.4453 13.1531V20.7986H31.2809C31.8246 20.7986 32.2653 21.2113 32.2653 21.7204C32.2653 22.2296 31.8246 22.6423 31.2809 22.6423H22.4609C21.9173 22.6423 21.4766 22.2296 21.4766 21.7204V13.1531C21.4766 12.644 21.9173 12.2313 22.4609 12.2313Z" fill="#0A4976"/>
                        </svg>
                        <p class="leading-snug text-left text-blue-500">
                            Add this appointment to your calendar
                            <!-- prettier-ignore -->
                            <svg class="inline" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-label="">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.62661 5.29327L0.758536 9.38454L1.7756 10.4005L6.73438 5.31743L1.80091 0.160767L0.734375 1.22731L4.62661 5.29327Z" fill="#004876"/>
                            </svg>
                        </p>
                    </a>
                </div>
                <div class="w-full px-6 py-10 md:px-10 md:w-1/2">
                    <div class="flex items-center mb-8">
                        <!-- prettier-ignore -->
                        <svg width="33" height="38" viewBox="0 0 33 38" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-label="">
                            <path d="M16.5015 21.0655C7.90229 21.0655 0.90625 28.061 0.90625 36.6598C0.90625 37.0452 1.2186 37.3581 1.6045 37.3581H31.3967C31.7821 37.3581 32.0949 37.0452 32.0949 36.6598C32.0949 28.061 25.0998 21.0655 16.5015 21.0655ZM24.1996 24.7359C23.1075 28.0406 20.0212 30.2587 16.5015 30.2587C12.9833 30.2587 9.89651 28.0406 8.80258 24.7359C11.0221 23.298 13.6657 22.462 16.5015 22.462C19.3369 22.462 21.98 23.298 24.1996 24.7359ZM2.31998 35.9616C2.52387 31.7711 4.5544 28.0531 7.62904 25.585C9.02602 29.2336 12.5271 31.6552 16.5015 31.6552C20.4769 31.6552 23.978 29.2341 25.3731 25.585C28.4473 28.0531 30.4778 31.7711 30.6817 35.9616H2.31998Z" fill="#004876"/>
                            <ellipse cx="17.668" cy="11.6817" rx="8.75" ry="8.75" fill="#FFC749"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9173 17.8067C20.2666 17.8067 23.7923 14.2809 23.7923 9.93169C23.7923 5.58245 20.2666 2.05669 15.9173 2.05669C11.5681 2.05669 8.04232 5.58245 8.04232 9.93169C8.04232 14.2809 11.5681 17.8067 15.9173 17.8067ZM15.9173 19.265C21.072 19.265 25.2507 15.0863 25.2507 9.93169C25.2507 4.77703 21.072 0.598358 15.9173 0.598358C10.7627 0.598358 6.58398 4.77703 6.58398 9.93169C6.58398 15.0863 10.7627 19.265 15.9173 19.265Z" fill="#004876"/>
                        </svg>
                        <p class="ml-4 text-lg font-medium text-blue-500">Your Details</p>
                    </div>

                    <ReviewSection
                        :fields="[
                            {
                                label: 'Name',
                                data: `${booking.details.firstName} ${booking.details.lastName}`
                            },
                            {
                                label: 'DOB',
                                data: booking.details.dob
                            }
                        ]"
                    />

                    <ReviewSection
                        :fields="[
                            {
                                label: 'Mobile number',
                                data: booking.details.phoneNumber
                            },
                            {
                                label: 'Member Number',
                                data: booking.details.membershipNumber
                            }
                        ]"
                    />

                    <ReviewSection
                        :fields="[
                            {
                                label: 'Person number (see back of card)',
                                data: booking.details.hicapsCode
                            },
                            {
                                label: 'New patient',
                                data: booking.newPatient ? 'Yes' : 'No'
                            }
                        ]"
                        class="-mb-6"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import alerts from '@/../vue/online-booking/mixins/alerts';
import ReviewSection from '@/../vue/online-booking/components/ReviewSection.vue';
import AlertBubbles from '@/../vue/online-booking/components/AlertBubbles.vue';
import { googleCalDate, toTimeString, toDateString } from '@/../vue/online-booking/utils/dates';

export default {
    components: {
        ReviewSection,
        AlertBubbles
    },

    mixins: [alerts],

    props: {
        uid: {
            type: String,
            required: true
        }
    },

    data: () => ({
        booking: null
    }),

    computed: {
        calendarLink() {
            const apt = this.booking.selectedAppointment;
            const name = `Health+Partners+${this.booking.serviceType.toLowerCase()}+appointment`;

            const start = googleCalDate(apt.appointmentDateTime);
            const end = googleCalDate(apt.appointmentEndDateTime);
            const location = `Health Partners ${apt.locationName}`;

            return `https://calendar.google.com/calendar/r/eventedit?text=${name}&dates=${start}/${end}&location=${location}`;
        },
        displayDate() {
            const apt = this.booking.selectedAppointment;
            const time = toTimeString(apt.appointmentTime);
            const date = toDateString(apt.appointmentDateTime, 'cccc d MMMM yyyy');
            return `${time}, ${date}`;
        },
        serviceType() {
            return this.booking.serviceType === 'Dental' ? 'Check up and clean' : 'Eye test';
        },
        practitionerType() {
            return this.booking.serviceType === 'Dental' ? 'Dentist' : 'Optometrist';
        }
    },

    created() {
        this.getBooking();
    },

    methods: {
        getBooking() {
            const booking = JSON.parse(window.localStorage.getItem('booking'));
            if (booking) {
                this.booking = booking;
            } else {
                this.addAlert({
                    type: 'error',
                    text: `There has been a problem retrieving your booking information.`
                });
            }
        }
    }
};
</script>
